import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal } from 'antd';
import BwgButton from '../../atoms/Button';

const Column = styled.td`
  > button {
    text-align: left;
    padding-left: 0;
    padding-right: 0;
    max-width: 110px;

    > span {
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow-x: clip;
    }
  }
`;

function ObservacaoColumn({ observacao }) {
  if (!observacao) {
    return <Column />;
  }

  const handleVisalizarObservacaoClick = () => {
    Modal.warning({
      centered: true,
      width: 560,
      title: 'Observação',
      icon: <div />,
      content: observacao,
      okText: 'Fechar',
      maskClosable: true,
    });
  };

  return (
    <Column onClick={(e) => e.stopPropagation()}>
      <BwgButton
        type="link"
        data-testid="btn-observacao"
        onClick={() => handleVisalizarObservacaoClick()}
      >
        {observacao}
      </BwgButton>
    </Column>
  );
}

ObservacaoColumn.propTypes = {
  observacao: PropTypes.string,
};

ObservacaoColumn.defaultProps = {
  observacao: undefined,
};

export default ObservacaoColumn;
